import React, { useState, useEffect }  from 'react'
import {config} from '../config'
import Modal from 'react-bootstrap/Modal'
import * as txApi from '../clients/tx-sls-client'
const txdomain = config()['tourneyx-url']
const linodeurl = config()['linode-url']

//Added by Naveen - If linode option is 1 then image load from linode and 0 then image load from server.
const Ads = ({ads}) => {
 const [linodeoption,setLinodeoption] = useState('');
 useEffect(() =>{
     txApi.getImageSourceOption('load_images_from_linode').then((response)=>{
         setLinodeoption(response);
        })
 },[]);

console.log('React- Ads.js linodeoption',linodeoption);
 if(linodeoption != '' && linodeoption == 1){
  //linode
  return (
    <>
      {
        (!ads)
          ? <></>
          : ads.map((ad, index) =>
              <div key={`addiv${index}`} className="tourney-ad-block">
                <a key={`adlink${index}`} href={`${txdomain}/app/ad-click.php?url=${ad.ad_url}&id=${ad.id}`} target="_blank">
                  <img key={`adimg${index}`} src={`${linodeurl}/ads/${ad.img_name}`} />
                </a>
              </div>
            )

      }
    </>
  )
}else{
  //server
  return (
    <>
      {
        (!ads) 
          ? <></> 
          : ads.map((ad, index) =>
              <div key={`addiv${index}`} className="tourney-ad-block">
                <a key={`adlink${index}`} href={`${txdomain}/app/ad-click.php?url=${ad.ad_url}&id=${ad.id}`} target="_blank">
                  <img key={`adimg${index}`} src={`${txdomain}/app/lib/ads/${ad.img_name}`} />
                </a>
              </div>
            )
      }
    </>
  )
}   
}
export default Ads